<template>
  <v-stepper
    flat
    alt-labels
    v-model="currentStep"
    class="d-flex flex-column fill-height">
    <v-stepper-header class="d-flex flex-shrink-0 flex-grow-0">
      <v-container class="stepper-header-container">
        <v-stepper-step step="1">
          <span>{{ $t('stepper.rdv') }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">
          <span>{{ $t('stepper.map') }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">
          <span>{{ $t('stepper.identifier') }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4">
          <span>{{ $t('stepper.personnalData') }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="5">
          <span>{{ $t('stepper.employer') }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="6">
          <span>{{ $t('stepper.contact') }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="7">
          <span>{{ $t('stepper.physicians') }}</span>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="8">
          <span>{{ $t('stepper.insurances') }}</span>
        </v-stepper-step>
      </v-container>
    </v-stepper-header>
    <v-stepper-items class="d-flex flex-grow-1 flex-shrink-0">
      <v-stepper-content class="pa-0 ma-0" step="1">
        <StepContent :enableBack="false">
          <RdvStep></RdvStep>
        </StepContent>
      </v-stepper-content>
      <v-stepper-content class="pa-0 ma-0" step="2">
        <StepContent>
          <InsuranceCardStep></InsuranceCardStep>
        </StepContent>
      </v-stepper-content>
      <v-stepper-content class="pa-0 ma-0" step="3">
        <StepContent>
          <IdentifierStep></IdentifierStep>
        </StepContent>
      </v-stepper-content>
      <v-stepper-content class="pa-0 ma-0" step="4">
        <StepContent>
          <PersonalDataStep></PersonalDataStep>
        </StepContent>
      </v-stepper-content>
      <v-stepper-content class="pa-0 ma-0" step="5">
        <StepContent>
          <EmployerStep></EmployerStep>
        </StepContent>
      </v-stepper-content>
      <v-stepper-content class="pa-0 ma-0" step="6">
        <StepContent>
          <ContactStep></ContactStep>
        </StepContent>
      </v-stepper-content>
      <v-stepper-content class="pa-0 ma-0" step="7">
        <StepContent>
          <DoctorStep></DoctorStep>
        </StepContent>
      </v-stepper-content>
      <v-stepper-content class="pa-0 ma-0" step="8">
        <StepContent>
          <AssuranceStep></AssuranceStep>
        </StepContent>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script lang="js">
import {mapState} from 'vuex'
import InsuranceCardStep from './steps/InsuranceCardStep.vue';
import StepContent from './ui/StepContent.vue';
import IdentifierStep from './steps/IdentifierStep.vue';
import RdvStep from './steps/RdvStep.vue';
import PersonalDataStep from './steps/PersonalDataStep.vue';
import EmployerStep from './steps/EmployerStep.vue';
import ContactStep from "./steps/ContactStep.vue";
import AssuranceStep from "@/components/steps/AssuranceStep";
import DoctorStep from "@/components/steps/DoctorStep";

export default {
  components: {
    AssuranceStep,
    ContactStep,
    InsuranceCardStep,
    StepContent,
    IdentifierStep,
    RdvStep,
    PersonalDataStep,
    EmployerStep,
    DoctorStep
  },
  computed: {
    ...mapState('navigation', ['currentStep']),
  },
}
</script>
<style lang="scss">
.stepper-header-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.v-stepper__label {
  font-size: 10px;
  display: flex;
}

.v-stepper__wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.v-stepper:not(.v-stepper--vertical) .v-stepper__label {
  display: flex !important;
}

.v-stepper .v-stepper__step {
  flex-basis: 0 !important;
  padding: 12px;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 23px -6px 0 -6px !important;
}

@media only screen and (max-width: 959px) {
  .stepper-header-container .v-divider {
    display: none;
  }
  .v-stepper__label span {
    display: none !important;
  }
  .v-stepper .v-stepper__step {
    padding: 3px;
  }
  .v-stepper:not(.v-stepper--vertical) .v-stepper__step__step {
    margin: 0;
  }
}
</style>
